import { Link, NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, FileText, UserRound, Briefcase, Users, LogOut, FolderOpen, Handshake } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const candidateNav = [
  { to: "/candidate", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/candidate/onboarding", label: "My Profile", icon: UserRound },
  { to: "/candidate/documents", label: "Documents", icon: FolderOpen },
];

const employerNav = [
  { to: "/employer", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/employer/submit-role", label: "Submit a Role", icon: Briefcase },
  { to: "/employer/shortlist", label: "Shortlist", icon: Users },
  { to: "/employer/partnership", label: "Membership", icon: Handshake },
  { to: "/employer/documents", label: "Documents", icon: FileText },
];

export const PortalLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const items = user?.role === "employer" ? employerNav : candidateNav;

  return (
    <div className="min-h-screen flex bg-[#f5f3ee]">
      <aside className="hidden md:flex w-60 flex-col bg-[#0d2f4d] text-white fixed inset-y-0" data-testid="portal-sidebar">
        <div className="px-6 py-6">
          <Link to="/" className="block">
            <span className="font-heading font-extrabold text-base">THE DITCH</span>
            <span className="font-heading font-bold text-base text-[#C1CC24] ml-1.5">Careers</span>
          </Link>
          <p className="text-[10px] uppercase tracking-[0.25em] text-white/40 mt-1">
            {user?.role === "employer" ? "Employer Portal" : "Candidate Portal"}
          </p>
        </div>
        <nav className="flex-1 px-3 space-y-1">
          {items.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end} data-testid={`sidebar-${label.toLowerCase().replace(/ /g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors ${
                  isActive ? "bg-white/10 text-white" : "text-white/60 hover:text-white hover:bg-white/5"
                }`}>
              <Icon size={17} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="px-3 pb-6">
          <div className="px-3 py-2 text-xs text-white/50 truncate">{user?.email}</div>
          <button onClick={async () => { await logout(); navigate("/"); }} data-testid="logout-button"
            className="flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm text-white/60 hover:text-white hover:bg-white/5 transition-colors">
            <LogOut size={17} /> Sign out
          </button>
        </div>
      </aside>
      <div className="flex-1 md:ml-60">
        <div className="md:hidden flex items-center justify-between bg-[#0d2f4d] text-white px-4 py-3">
          <Link to="/" className="font-heading font-extrabold text-sm">THE DITCH <span className="text-[#C1CC24]">Careers</span></Link>
          <button onClick={async () => { await logout(); navigate("/"); }} data-testid="logout-button-mobile" className="text-white/70"><LogOut size={18} /></button>
        </div>
        <div className="md:hidden flex gap-2 overflow-x-auto bg-[#0d2f4d] px-4 pb-3">
          {items.map(({ to, label, end }) => (
            <NavLink key={to} to={to} end={end}
              className={({ isActive }) => `whitespace-nowrap rounded-full px-3 py-1 text-xs ${isActive ? "bg-white text-[#0d2f4d]" : "bg-white/10 text-white/70"}`}>
              {label}
            </NavLink>
          ))}
        </div>
        <main className="p-6 lg:p-10 max-w-6xl">{children}</main>
      </div>
    </div>
  );
};
